var _path, _mask, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.35112 15.1488C9.35131 15.619 8.97013 16.0002 8.50016 16C8.27314 16 8.05783 15.9104 7.89825 15.7508C7.73868 15.5912 7.64906 15.3759 7.64907 15.149L7.64919 9.35105L1.85119 9.35102C1.62421 9.35102 1.40891 9.26141 1.24934 9.10184C1.08987 8.94236 1.00019 8.72714 1 8.50015C0.99981 8.0301 1.38103 7.64892 1.85097 7.64911L7.64907 7.64914L7.64904 1.85118C7.64885 1.38103 8.03003 0.99981 8.5 1C8.97025 0.99999 9.3511 1.3808 9.35109 1.85102L9.35112 7.6491L15.149 7.64898C15.6192 7.64897 16 8.0298 16 8.49986C16.0002 8.97002 15.619 9.35124 15.149 9.35105L9.35109 9.35118L9.35112 15.1488Z",
    fill: "#1E2447",
    stroke: "#1E2447",
    strokeWidth: 0.2
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 17,
    height: 17
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.35112 15.1488C9.35131 15.619 8.97013 16.0002 8.50016 16C8.27314 16 8.05783 15.9104 7.89825 15.7508C7.73868 15.5912 7.64906 15.3759 7.64907 15.149L7.64919 9.35105L1.85119 9.35102C1.62421 9.35102 1.40891 9.26141 1.24934 9.10184C1.08987 8.94236 1.00019 8.72714 1 8.50015C0.99981 8.0301 1.38103 7.64892 1.85097 7.64911L7.64907 7.64914L7.64904 1.85118C7.64885 1.38103 8.03003 0.99981 8.5 1C8.97025 0.99999 9.3511 1.3808 9.35109 1.85102L9.35112 7.6491L15.149 7.64898C15.6192 7.64897 16 8.0298 16 8.49986C16.0002 8.97002 15.619 9.35124 15.149 9.35105L9.35109 9.35118L9.35112 15.1488Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/Plus.882cb758.svg";
export { ForwardRef as ReactComponent };